import React from 'react';
import IconButton from 'material-ui/IconButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import './Chapters.css';
import getScoreClass from '../modules/scoreclass';

class MobileChapters extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.activeText !== prevProps.activeText) {
      if (this.activeListItem) {
        this.activeListItem.scrollIntoView();
      }
    }
  }

  /* We want to display the *highest* score in the navigation, not the *latest* one.
  * The score const below will search through the array and return the highest score,
  * which will be used to decide the element class.
  */
  renderSelector(key, index) {
    if (this.props.texts.length <= 1) {
      return <span key={index} />;
    }

    const tries = key.results.length;
    const active = this.props.activeText === index;
    const scoreArray = key.results.map(result => parseInt(result.score, 10));
    const score = parseInt(Math.max(...scoreArray), 10);
    const scoreClass = getScoreClass(score, tries);

    return (
      <li
        className={active ? 'active' : ''}
        key={index}
        title={`You have tried this ${tries} times`}
        ref={(li) => { if (active) this.activeListItem = li; }}
      >
        <button
          disabled={!this.props.isStopped()}
          onClick={() => this.props.dispatch(this.props.selectText(index))}
        >{index + 1}</button>
        <div className={`progress-indicator ${scoreClass}`} />
      </li>
        );
  }

  render() {
    const active = this.props.activeText;
    const disabled = !this.props.isStopped() || this.props.texts.length === 0;

    const disabledPrev = disabled || active === 0;
    const disabledNext = disabled || this.props.texts.length - 1 === active;

    return (
      <div className="pronounce-chapters">
        <IconButton className="mobile-prev" onClick={() => this.props.dispatch(this.props.prev())} disabled={disabledPrev}>
          <ChevronLeft />
        </IconButton>
        <ul ref={(ul) => { this.list = ul; }}>
          {this.props.texts.map((key, index) => this.renderSelector(key, index))}
        </ul>
        <IconButton className="mobile-next" onClick={() => this.props.dispatch(this.props.next())} disabled={disabledNext}>
          <ChevronRight />
        </IconButton>
      </div>
        );
  }
}

export default MobileChapters;



// WEBPACK FOOTER //
// ./src/components/MobileChapters.js